.ed{aspect-ratio:1/1;}